<template>
  <div class="customization-pop-content body-stop-scroll">
    <div :class="[clientPlatform == 'Web' ? 'ta-content' : '']">
      <div class="ta-lft">
        <div
          class="d-flex justify-content-between takeAwayHeader align-items-center"
        >
          <h1 class="fs-16 bold">Restaurants near you</h1>
          <div
            v-if="clientPlatform !== 'Web'"
            :class="[!isListView ? 'list-cta' : 'map-cta']"
            @click="toggleView"
          >
            <i
              class="color-error"
              :class="[!isListView ? 'hkfi-list-icon' : 'hkfi-map-icon']"
            ></i>
            <span class="fs-14 pl4">{{ !isListView ? "List" : "Map" }}</span>
            <!-- <img :src="toggleImage" class="toggleImg" @click="toggleView" /> -->
          </div>
        </div>
        <div
          v-if="
            (clientPlatform == 'Web' && takeawayStoreList?.length > 0) ||
            (isListView && takeawayStoreList?.length > 0)
          "
          class="pb16"
        >
          <div
            v-for="(item, index) in takeawayStoreList"
            :key="item?.store?.id"
            class="aligncenter pt12 pl16 pr16"
          >
            <address-card
              :data-item="item.store"
              :data-title="item.store.name"
              :data-address="item.store.address"
              :data-distance="item.store.stations[0].driveDistanceInKm"
              :data-time="item.store.stations[0].driveTimeInSec"
              :data-is-store-open="item.store.pickUpEnable"
              :data-store-id="item.store.id"
              :data-action-cta="'Select'"
              :data-index="index"
              :data-container-type="isListView ? 'list' : 'map'"
              :data-on-card-click="() => {}"
            >
            </address-card>
          </div>
        </div>
      </div>

      <div class="ta-rgt">
        <div
          v-if="
            (clientPlatform == 'Web' && takeawayStoreList?.length > 0) ||
            (!isListView && takeawayStoreList?.length > 0)
          "
          class="pt12"
        >
          <map-component
            :initializeMapFeatures="initializeMapFeatures"
            :mapCenter="mapCenterPos"
            :currentLoc="currentLocation"
          ></map-component>
          <div
            v-if="clientPlatform !== 'Web' && takeawayStoreList?.length > 0"
            class="payment-offer-wrap mb32 bottom-carousel"
            :class="[
              takeawayStoreList?.length == 1
                ? 'bottom-carousel-single-item'
                : '',
            ]"
          >
            <div class="col-sm">
              <Carousel
                ref="carousel"
                :pauseAutoplayOnHover="true"
                :transition="500"
                :itemsToShow="1.13"
                :mouseDrag="true"
                :touchDrag="true"
                :itemsToScroll="takeawayStoreList?.length"
                :snapAlign="'start'"
              >
                <Slide v-for="(item, index) in takeawayStoreList" :key="index">
                  <div
                    class="horizontal-carousel-takeaway"
                    :style="{ background: 'white' }"
                  >
                    <address-card
                      ref="addressCards"
                      :data-item="item.store"
                      :data-title="item.store.name"
                      :data-address="item.store.address"
                      :data-distance="item.store.stations[0].driveDistanceInKm"
                      :data-time="item.store.stations[0].driveTimeInSec"
                      :data-is-store-open="item.store.pickUpEnable"
                      :data-store-id="item.store.id"
                      :data-action-cta="'Select'"
                      :data-index="index"
                      :data-container-type="isListView ? 'list' : 'map'"
                      :data-apply-observer="true"
                      :data-on-intersection="storeObservedInCarousel"
                      :data-on-card-click="onAddressCardClick"
                    >
                    </address-card>
                  </div>
                </Slide>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="takeawayStoreList?.length == 0" class="no-stores">
      <h1 class="fs-16 color-slaty bold">Coming soon near you!</h1>
      <p class="fs-14 takeawaytext">
        We are not yet serviceable in your region currently.
      </p>
    </div>
  </div>
</template>

<script>
// import Map from "../../../default/images/global/Map.svg";
// import List from "../../../default/images/global/List.svg";
import "vue3-carousel/dist/carousel.css";
import MapComponent from "./MapComponent.vue";
import GenericModal from "./GenericModal.vue";
import AddressCard from "./AddressCard.vue";
import { Carousel, Slide } from "vue3-carousel";
import { keyMapsMutation } from "../helpers/storeKeys";
import LogoMarker from "../../../default/images/global/hongs-default-img-lg.png";
import CurLocLogo from "../../../default/images/global/curLocLogo.svg";
import MapUtils from "./../helpers/mapUtils";
import {
  EVENT_IMPRESSION_RESTAURANT_SELECTION,
  EVENT_CLICK_MAP_OR_LIST_VIEW,
} from "../helpers/analyticsEvents";
import { OrderTypesFromCode } from "./../helpers/orderTypesConstants";
import { clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "TakeAwayPageBody",
  components: {
    MapComponent,
    GenericModal,
    AddressCard,
    Carousel,
    Slide,
  },
  data() {
    return {
      clientPlatform,
      LogoMarker,
      CurLocLogo,
      // Map,
      // List,
      isListView: true,
      currentLoc: {},
      mapComponent: {},
      activeMarker: null,
    };
  },
  mounted() {
    EVENT_IMPRESSION_RESTAURANT_SELECTION({
      sectionName: "restaurant selection " + (this.isListView ? "map" : "list"),
      category: OrderTypesFromCode[this.selectedOrderType],
    });
  },
  methods: {
    toggleView() {
      EVENT_CLICK_MAP_OR_LIST_VIEW({
        category: OrderTypesFromCode[this.selectedOrderType],
        subCategory: this.isListView ? "map" : "list",
      });
      this.isListView = !this.isListView;
    },
    slideTo(val) {
      const myCarousel = this.$refs.carousel;
      myCarousel.slideTo(val);
    },
    currentLocationMarkerOnMap(map) {
      let currentLocation = this.currentLoc;
      const posImage = {
        url: CurLocLogo,
        scaledSize: new google.maps.Size(52, 52),
        anchor: new google.maps.Point(20, 20),
      };
      const markerView = MapUtils.addMarker({
        map: map,
        position: currentLocation,
        icon: posImage,
      });
    },
    addStoreMarkersOnMap(map) {
      let currentLocation = this.currentLoc;
      let takeawayStores = this.$store.state.Location.takeawayStoreList;
      const activeMarkerImage = {
        url: LogoMarker,
        scaledSize: new google.maps.Size(72, 72),
      };
      takeawayStores.forEach((place, index) => {
        const lat = place.store.stations[0].latitude;
        const lng = place.store.stations[0].longitude;
        const markerImage = {
          url: LogoMarker,
          scaledSize: new google.maps.Size(52, 52),
        };

        let marker = MapUtils.addMarker({
          position: { lat: lat, lng: lng },
          map: map,
          icon: markerImage,
        });

        marker.addListener("click", () => {
          let pos = marker.getPosition();
          this.activeMarker.setPosition(pos);

          this.focusStoreSlideByLocation(index, map);
        });
      });
      this.activeMarker = MapUtils.addMarker({
        map: map,
        icon: activeMarkerImage,
      });
      // commented driving directions to maintain uniformity with android
      // MapUtils.showDrivingDirection({
      //   origin: currentLocation,
      //   destination: {
      //     lat: takeawayStores[0].store.stations[0].latitude,
      //     lng: takeawayStores[0].store.stations[0].longitude,
      //   },
      //   map: map,
      // });
      map.setZoom(13);
      this.mapComponent = map;
    },
    focusStoreSlideByLocation(index, map) {
      let currentLocation = this.currentLoc;
      let takeawayStores = this.$store.state.Location.takeawayStoreList;
      this.$store.commit(keyMapsMutation.UPDATE_FOCUSED_STORE, index);
      // commented driving directions to maintain uniformity with android
      // MapUtils.showDrivingDirection({
      //   origin: currentLocation,
      //   destination: {
      //     lat: takeawayStores[index].store.stations[0].latitude,
      //     lng: takeawayStores[index].store.stations[0].longitude,
      //   },
      //   map: map,
      // });
      map.setCenter({
        lat: takeawayStores[index].store.stations[0].latitude,
        lng: takeawayStores[index].store.stations[0].longitude,
      });
      map.setZoom(13);
    },
    initializeMapFeatures(map, mapRef) {
      this.currentLocationMarkerOnMap(map);
      this.addStoreMarkersOnMap(map);
    },
    storeObservedInCarousel(index) {
      if (this.activeMarker) {
        let currentLocation = this.currentLoc;
        let takeawayStores = this.$store.state.Location.takeawayStoreList;
        // commented driving directions to maintain uniformity with android
        // MapUtils.showDrivingDirection({
        //   origin: currentLocation,
        //   destination: {
        //     lat: takeawayStores[index].store.stations[0].latitude,
        //     lng: takeawayStores[index].store.stations[0].longitude,
        //   },
        //   map: this.mapComponent,
        // });
        this.mapComponent.setCenter({
          lat: takeawayStores[index].store.stations[0].latitude,
          lng: takeawayStores[index].store.stations[0].longitude,
        });
        this.activeMarker.setPosition({
          lat: takeawayStores[index].store.stations[0].latitude,
          lng: takeawayStores[index].store.stations[0].longitude,
        });
        this.mapComponent.setZoom(13);
      }
    },
    onAddressCardClick(index) {
      if (this.activeMarker) {
        let currentLocation = this.currentLoc;
        let takeawayStores = this.$store.state.Location.takeawayStoreList;

        this.$store.commit(keyMapsMutation.UPDATE_FOCUSED_STORE, index);
        // commented driving directions to maintain uniformity with android
        // MapUtils.showDrivingDirection({
        //   origin: currentLocation,
        //   destination: {
        //     lat: takeawayStores[index].store.stations[0].latitude,
        //     lng: takeawayStores[index].store.stations[0].longitude,
        //   },
        //   map: this.mapComponent,
        // });
        this.mapComponent.setCenter({
          lat: takeawayStores[index].store.stations[0].latitude,
          lng: takeawayStores[index].store.stations[0].longitude,
        });
        this.activeMarker.setPosition({
          lat: takeawayStores[index].store.stations[0].latitude,
          lng: takeawayStores[index].store.stations[0].longitude,
        });
        this.mapComponent.setZoom(13);
      }
    },
  },
  watch: {
    focusedStore(newfocusedStore) {
      this.slideTo(newfocusedStore);
    },
  },
  computed: {
    // toggleImage() {
    //   return this.isListView ? this.Map : this.List;
    // },
    takeawayStoreList() {
      return this.$store.state.Location.takeawayStoreList;
    },
    focusedStore() {
      return this.$store.state.Location.focusedStore;
    },
    currentLocation() {
      let currentLocationFromStorage =
        LocalStorageFunc.getCoordsFromRecentLocation()?.coords;

      this.currentLoc = this.$store.state.Location.currentLocation?.lat
        ? this.$store.state.Location.currentLocation
        : currentLocationFromStorage
        ? {
            lat: currentLocationFromStorage.latitude,
            lng: currentLocationFromStorage.longitude,
          }
        : {};
      return this.currentLoc;
    },
    deliveryType() {
      return this.$store.state.User.currentOrderType;
    },
    selectedOrderType() {
      return (
        LocalStorageFunc.getSelectedDeliveryType() ||
        this.$store.state.User.currentOrderType
      );
    },
    mapCenterPos() {
      const lat =
        this.$store.state.Location.takeawayStoreList[0]?.place?.store
          ?.stations[0]?.latitude;
      const lng =
        this.$store.state.Location.takeawayStoreList[0]?.place?.store
          ?.stations[0]?.longitude;
      return lat ? { lat: lat, lng: lng } : this.currentLoc;
    },
  },
};
</script>

<style></style>
